import {Modal, ModalBody} from 'reactstrap';
import classnames from 'classnames';

import {colorTag} from 'src/state/dependency2';
import {LoadingPlaceholder} from 'src/components';
import {ModalCloseButton} from 'src/components';
import {useNode} from 'src/hooks';

import {NodeDetail} from '../NodeDetail';

import {Props} from './types';

import './styles.css';


export const NodeDetailModal = ({isOpen, toggle, nodeId, goToNode}: Props) => {
  const {loading, node} = useNode(nodeId);

  const {color: borderColor} = node?.type ? colorTag(node?.type) : {color: undefined};

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      fade={false}
      modalClassName="NodeDetailModal"
      fullscreen
    >
      <ModalBody className={classnames({
        'NodeDetailModalBody': true,
      })} style={{borderColor}}>

        {loading || !node ? <LoadingPlaceholder /> : <div><NodeDetail goToNode={goToNode} node={node} /></div>}
      </ModalBody>
      <ModalCloseButton toggle={toggle} />
    </Modal>
  );
};
